<script setup>
import useGrid from "@/composables/useGrid";
import needsService from "@/services/needs.service";
import Grid from "../../../../frontend/src/components/Grid.vue";
import {onMounted, ref} from "vue";
import {publicStatuses, statuses} from "../../../../frontend/src/constants/needs"
import FoundStartups from "@/views/needs/FoundStartups.vue";

const {items, gridParams, gridMethods} = useGrid(needsService.getList);

const statusOptions = Object.keys(statuses).map(key => ({id: key, name: statuses[key]}));
const publicStatusOptions = Object.keys(publicStatuses).map(key => ({id: key, name: publicStatuses[key]}));

const columns = [
    {
        label: 'ID',
        name: 'id',
        sortable: true,
    },
    {
        label: 'Name',
        name: 'name',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Description',
        name: 'description',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Enterprise',
        name: 'enterprise_name',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Sponsor label',
        name: 'sponsor_label',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Created by',
        name: 'user_email',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Created At',
        name: 'created_at',
        sortable: true,
    },
    {
        label: 'Ecosystems Share Type',
        name: 'ecosystems_share_type',
        sortable: true,
        filter: 'single-select',
        options: [
            {
                id: 'all',
                name: 'All'
            },
            {
                id: 'connected',
                name: 'Connected'
            },
            {
                id: 'none',
                name: 'None'
            }
        ],
    },
    {
        label: 'Public Status',
        name: 'public_status',
        sortable: true,
        filter: 'single-select',
        options: publicStatusOptions,
    },
    {
        label: 'Status',
        name: 'status',
        sortable: true,
        filter: 'single-select',
        options: statusOptions,
    },
    {
        label: 'Added by AI',
        name: 'ai_count',
        sortable: true,
    },
    {
        label: 'Added by Ecosystem',
        name: 'eco_count',
        sortable: true,
    },
    {
        label: 'Startups Found',
        name: 'found_startups_count',
        sortable: true,
        component: 'Link',
    },
    {
        label: 'Liked',
        name: 'liked_count',
        sortable: true,
    },
    {
        label: 'Disliked',
        name: 'disliked_count',
        sortable: true,
    },
    {
        name: 'actions',
        label: 'Link',
        component: 'Link',
    },
];

const publicStatus = ref(null)
const foundStartups = ref(null)

onMounted(() => {
    gridParams.sort = {
        field: 'id',
        dir: 'desc',
    };

    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

async function changePublicStatus() {
    await needsService.setPublicStatus(gridParams.selectedRows, publicStatus.value);

    gridMethods.resetList();
    publicStatus.value = '';
}

function action(params) {
    if (params.action === 'show_found_startups') {
        foundStartups.value.open(params.rowId);
    }
}

</script>

<template>
    <div>
        <div class="topbar">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="buttons-container">
                        <template v-if="gridParams.selectedRows.length">
                            <select v-model="publicStatus" class="multiselect multiselect-mid">
                                <option value=""></option>
                                <option v-for="(name, id) in publicStatuses" :key="id" :value="id">
                                    {{name}}
                                </option>
                            </select>

                            <button
                                class="button button--sm"
                                :disabled="!publicStatus"
                                @click="changePublicStatus"
                            >
                                Change public status
                            </button>
                        </template>
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    has-filters
                    has-checkbox-column
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                    @changeFilters="gridMethods.setFilters"
                    @changeSort="gridMethods.changeSort"
                    @selectedRowsChanged="gridMethods.changeSelectedRows"
                    @action="action"
                />
            </div>
        </div>

        <FoundStartups ref="foundStartups"/>
    </div>
</template>

<style scoped>

</style>
